import { useLanguage } from "./LanguageContext";
import "./CTAJobs.css";

const CTAJobs = () => {
  const { t } = useLanguage();

  const faqs = [
    { question: t("faqQ1"), answer: t("faqA1") },
    { question: t("faqQ2"), answer: t("faqA2") },
    { question: t("faqQ3"), answer: t("faqA3") },
    { question: t("faqQ4"), answer: t("faqA4") },
    { question: t("faqQ5"), answer: t("faqA5") },
    { question: t("faqQ6"), answer: t("faqA6") },
    { question: t("faqQ7"), answer: t("faqA7") },
    { question: t("faqQ8"), answer: t("faqA8") },
  ];

  return (
    <section id="faq-section" className="py-5">
      <div className="container">
        <div className="row justify-content-center mb-4">
          <div className="col-auto">
            <h2 className="faq-title text-center">{t("faqTitle")}</h2>
          </div>
        </div>

        <div className="row text-center g-4 justify-content-center">
          {faqs.map((f, idx) => (
            <div className="col-12 col-xxl-3 col-xl-4 col-md-6 col-sm-12" key={idx}>
              <div className="faq-card p-4 h-100">
                <h3 className="faq-question h6 fw-semibold mb-2">{f.question}</h3>
                <p className="faq-answer">{f.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTAJobs;
